import { render, staticRenderFns } from "./TenAnniversaryPromoBanner.vue?vue&type=template&id=f2e72970&scoped=true&"
import script from "./TenAnniversaryPromoBanner.vue?vue&type=script&lang=js&"
export * from "./TenAnniversaryPromoBanner.vue?vue&type=script&lang=js&"
import style0 from "./TenAnniversaryPromoBanner.vue?vue&type=style&index=0&id=f2e72970&prod&lang=scss&scoped=true&"
import style1 from "./TenAnniversaryPromoBanner.vue?vue&type=style&index=1&id=f2e72970&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e72970",
  null
  
)

export default component.exports